import { DataAttributeDefinitions } from 'scrivito'

import { pisaIndustryDataClass } from './Pisa/pisaIndustryDataClass'

const attributes: DataAttributeDefinitions = {}

export const Industry = pisaIndustryDataClass(attributes)
